import ResetPasswordPage from "./components/reset-password/ResetPasswordPage";
import "./styles/Auth.module.css";

const ResetPassword = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <ResetPasswordPage />
      </div>
    </div>
  );
};

export default ResetPassword;
